import React from 'react'
import useCards from '../../../hooks/useCards'

const ValorFacturaCards = () => {
  const { homeinCards } = useCards()
  
  return (
      <>
          {homeinCards(15)}

      </>
  )
} 

export default ValorFacturaCards